import { render, staticRenderFns } from "./createGroup.vue?vue&type=template&id=160a4073&scoped=true"
import script from "./createGroup.vue?vue&type=script&lang=js"
export * from "./createGroup.vue?vue&type=script&lang=js"
import style0 from "./createGroup.vue?vue&type=style&index=0&id=160a4073&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160a4073",
  null
  
)

export default component.exports